const config = {
  mainFacility: 'f8164302-4b21-4fc0-a5c0-b898d9408074',
  googlePlaceId: 'ChIJexSN7DiLGGARcV-_JHR9AKY',
  assetsBucketUrl: 'https://s3.ap-northeast-1.amazonaws.com/net.cocodakara.bodydesign.assets/',
  v2PathPatternsToReload: [
    '/',
    '/terms-of-service',
    '/privacy-policy',
    '/faq',
    '/price',
    '/gallery',
    '/articles*',
    '/training-plan*',
  ],
};

export default config;
